const SectionWrapper = ({ children }) => {
  return (
    <div className="bg-white shadow-hairline ring-1 ring-ink-100 px-4 sm:px-6 lg:px-10 py-6 sm:py-8 lg:py-10 rounded-card">{children}</div>
  );
};

export default SectionWrapper;
